import { render, staticRenderFns } from "./PersonItem.vue?vue&type=template&id=79c57270&scoped=true&"
import script from "./PersonItem.vue?vue&type=script&lang=ts&"
export * from "./PersonItem.vue?vue&type=script&lang=ts&"
import style0 from "./PersonItem.vue?vue&type=style&index=0&id=79c57270&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c57270",
  null
  
)

export default component.exports